import { memo } from 'react'
import { Icon } from '@iconify/react'
import {
  CAMPAIGN_SOCIAL_LINK_FIELDS,
  hasLandingSocialLinks,
  type CampaignSocialLinks,
} from '@/lib/campaign-social-links'
import styles from './LandingFooterSocialLinks.module.css'

type LandingFooterSocialLinksProps = {
  links: CampaignSocialLinks
  containerClassName?: string
  linkClassName?: string
}

export const LandingFooterSocialLinks = memo(function LandingFooterSocialLinks({
  links,
  containerClassName,
  linkClassName,
}: LandingFooterSocialLinksProps) {
  if (!hasLandingSocialLinks(links)) {
    return null
  }

  const containerClass = containerClassName
    ? `${styles.socialLinks} ${containerClassName}`
    : styles.socialLinks

  return (
    <div className={containerClass} aria-label="Redes sociais">
      {CAMPAIGN_SOCIAL_LINK_FIELDS.map((field) => {
        const href = links[field.key]
        if (!href) {
          return null
        }

        const linkClass = linkClassName
          ? `${styles.socialLink} ${linkClassName}`
          : styles.socialLink

        return (
          <a
            key={field.key}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
            aria-label={field.label}
            title={field.label}
          >
            <Icon icon={field.icon} aria-hidden />
          </a>
        )
      })}
    </div>
  )
})
